export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./baas.vue?vue&type=template&id=f49c47e2&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/baas.vue?vue&type=template&id=f49c47e2&scoped=true
// module id = b3q+
// module chunks = 0